<template>
  <div>
    <v-checkbox
      color="#FFA903"
      off-icon="mdi-checkbox-blank"
      v-model="checked"
      @change="$emit('input', $event)"
    >
      <template v-slot:label>
        <span>
          {{ bookData.privacyText }}
          <a
            class="link"
            target="_blank"
            @click.stop
            :href="require('../assets/lsaran-privacy-statement.pdf')"
          >
            {{ bookData.privacyLinkText }}
          </a>
        </span>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
export default {
  name: "PrivacyStatement",
  props: ["value"],
  computed: {
    bookData() {
      return this.$t("book");
    }
  },
  data() {
    return {
      checked: this.value
    };
  }
};
</script>

<style lang="sass" scoped>

.link
  color: inherit
  border-bottom: 1px solid rgba(0, 0, 0, .6)
</style>
